var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 91 91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e8e100;\n      }\n\n      .cls-2 {\n        fill: #647f94;\n      }\n\n      .cls-3 {\n        fill: #65b794;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24,49.4l18.1,18.1,38.1-38.1-18.1-18.1L24,49.4ZM66.4,25.1c1.3,1.3,1.3,3.3,0,4.6l-22.1,22.1c-.6.6-1.5.9-2.3.9s-1.7-.3-2.3-.9c-1.3-1.3-1.3-3.3,0-4.6l22.1-22.1c1.3-1.3,3.3-1.3,4.6,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "15.7 75.6 35.9 70.4 21.1 55.6 15.7 75.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.6,12.5l-8.6-8.6c-2.5-2.5-7-2.5-9.5,0l-2.8,2.8,18.1,18.1,2.8-2.8c2.6-2.6,2.6-6.9,0-9.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M79.6,89.6H3.5c-1.8,0-3.3-1.5-3.3-3.3V5.5C.1,3.7,1.6,2.2,3.5,2.2h51.1c1.8,0,3.3,1.5,3.3,3.3s-1.5,3.3-3.3,3.3H6.8v74.1h72.8c2.6,0,4.7-2.1,4.7-4.7v-41.6c0-1.8,1.5-3.3,3.3-3.3s3.3,1.5,3.3,3.3v41.6c0,6.3-5.1,11.3-11.3,11.3Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "18.9 13.4 18.9 21.6 11.3 21.5 11.3 27.4 19.1 27.3 19 35.2 26.1 35.2 25.8 27.9 34.3 27.6 34.1 21.7 26 21.9 25.8 13.6 18.9 13.4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit3);
export default __webpack_public_path__ + "static/media/edit3.3ce13402b16319481646ae08f8f880fe.svg";
export { ForwardRef as ReactComponent };